import React, { useState } from "react";
import Context from "../Context";
import { StackImages } from "./index";
import { FiShoppingCart } from "react-icons/fi";
import { Typo } from "./index";
import Lottie from "lottie-react";
import lottieCart from "../constants/lottie/cart.json";
import lottieTick from "../constants/lottie/tick.json";
import { Spinner } from "reactstrap";

export const ShopItem = ({ number, lotteries, isMagicNumber }) => {
  const { callApi, setCart, profileState } = Context();
  const [status, setStatus] = useState("available");
  const [onHover, setOnHover] = useState(false);
  const addCart = async () => {
    const isGuest = !profileState.userNo;
    const guestId = localStorage.guestId || false;
    // if (cart?.size >= 201) {
    //   return toast("จำกัดการซื้อสูงสุดไม่เกิน 200");
    // }

    // if (!localStorage.getItem("accessToken")) {
    //   return go("/login");
    // } else if (isGuest) {
    //   window.location.pathname.includes("/search") && window.location.reload();
    // }
    if (status === "inCart") {
      setStatus("loading");
      const cartResult = await callApi(
        "carts-removeCart",
        { number, guestId },
        { notShowLoading: true }
      );
      const { size, expireIn } = cartResult;
      if (cartResult !== false) {
        setStatus("available");
        setCart((prevState) => ({
          deliverChannel: prevState.deliverChannel || undefined,
          size,
          expireIn: expireIn,
        }));
      }
    } else if (status === "available") {
      setStatus("loading");
      const result = isGuest
        ? await callApi(
            "carts-addGuestCart",
            { number, guestId: guestId },
            { notShowLoading: true }
          )
        : await callApi("carts-addCart", { number }, { notShowLoading: true });

      const { size, expireIn } = result;

      if (!result.status) {
        setStatus("available");
        return;
      } else {
        if (result.guestId) {
          localStorage.setItem("guestId", result.guestId);
        }

        setStatus("inCart");
        setCart((prevState) => ({
          deliverChannel: prevState?.deliverChannel || undefined,
          size,
          expireIn: expireIn,
        }));
      }
    }
  };

  return (
    <div
      onMouseEnter={() => setOnHover(true)}
      onMouseLeave={() => setOnHover(false)}
      onClick={() => addCart() && setOnHover(false)}
      className="relative rounded-xl overflow-hidden hover:cursor-pointer h-fit [&_.child]:hover:flex hover:shadow-xl
      duration-150"
    >
      <StackImages
        limitHeight={true}
        status={status}
        isDisable={true}
        urls={lotteries ? lotteries.map((x) => [x.image]) : []}
        isMagicNumber={isMagicNumber}
      ></StackImages>
      <div className="bg-gray-800 p-2.5 flex items-center justify-center gap-2">
        <FiShoppingCart color="#FFCD00" />
        <Typo.Body8 color="white">{`เพิ่มลงในตะกร้า`}</Typo.Body8>
      </div>
      {status === "inCart" && (
        <div className="child w-full h-full flex flex-col gap-1 justify-center items-center absolute top-0 left-0 bg-[rgb(0,0,0,0.8)] duration-300">
          <Lottie
            animationData={lottieTick}
            style={{ width: "50px" }}
            loop={false}
          />
          <Typo.Body6 color="white">เพิ่มลงไปในตะกร้าแล้ว</Typo.Body6>
        </div>
      )}
      {status === "loading" && (
        <div className="child w-full h-full flex flex-col gap-1 justify-center items-center absolute top-0 left-0 bg-[rgb(0,0,0,0.8)] duration-300">
          <Spinner className="text-gold w-6 h-6" />
        </div>
      )}
      {onHover && !["bought", "inCart", "loading"].includes(status) && (
        <div className="child w-full h-full rounded-xl gap-1 justify-center items-center absolute top-0 left-0 bg-[rgb(0,0,0,0.8)] hidden duration-300">
          <Lottie animationData={lottieCart} style={{ width: "250px" }} />
        </div>
      )}
    </div>
  );
};
